/* eslint-disable react/prop-types */
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export function SmsUsageHistoryTable({ data = [], loading = false }) {
  const formatSmsCount = (count) => {
    if (count === undefined || count === null) return "0 SMS";
    const num = Number(count);
    return `${isNaN(num) ? count : num.toLocaleString()} SMS`;
  };

  const formatPerSmsCharge = (charge) => {
    if (charge === undefined || charge === null) return "£ 0.00";
    const num = Number(charge);
    if (isNaN(num)) return `£ ${charge}`;
    // For small fractional charges like 0.0011, show full decimal precision without trailing zeros truncating significant digits
    return num < 0.01 ? `£ ${num}` : `£ ${num.toFixed(2)}`;
  };

  const formatTotalCharge = (charge) => {
    if (charge === undefined || charge === null) return "£ 0.00";
    const num = Number(charge);
    if (isNaN(num)) return `£ ${charge}`;
    return `£ ${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  return (
    <div className="w-full overflow-x-auto">
      <Table className="w-full">
        <TableHeader>
          <TableRow className="border-b border-[#262a2e] hover:bg-transparent">
            <TableHead className="text-gray-400 font-medium text-sm py-3.5 px-4 text-left w-1/4">
              Month/ Cycle
            </TableHead>
            <TableHead className="text-gray-400 font-medium text-sm py-3.5 px-4 text-center w-1/4">
              Total SMS Send
            </TableHead>
            <TableHead className="text-gray-400 font-medium text-sm py-3.5 px-4 text-center w-1/4">
              Per SMS Charge
            </TableHead>
            <TableHead className="text-gray-400 font-medium text-sm py-3.5 px-4 text-right w-1/4">
              Total Charge
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {loading ? (
            [...Array(5)].map((_, i) => (
              <TableRow key={i} className="border-b border-[#262a2e]/60">
                <TableCell className="py-4 px-4">
                  <div className="h-4 bg-[#262a2e] rounded w-28 animate-pulse" />
                </TableCell>
                <TableCell className="py-4 px-4 text-center">
                  <div className="h-4 bg-[#262a2e] rounded w-20 mx-auto animate-pulse" />
                </TableCell>
                <TableCell className="py-4 px-4 text-center">
                  <div className="h-4 bg-[#262a2e] rounded w-16 mx-auto animate-pulse" />
                </TableCell>
                <TableCell className="py-4 px-4 text-right">
                  <div className="h-4 bg-[#262a2e] rounded w-16 ml-auto animate-pulse" />
                </TableCell>
              </TableRow>
            ))
          ) : data?.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={4}
                className="text-center py-10 text-gray-400 text-sm"
              >
                No SMS usage history found
              </TableCell>
            </TableRow>
          ) : (
            data.map((item, index) => (
              <TableRow
                key={index}
                className="border-b border-[#262a2e]/60 hover:bg-white/[0.02] transition-colors"
              >
                <TableCell className="py-4 px-4 text-sm text-gray-200 font-normal">
                  {item?.month || "N/A"}
                </TableCell>
                <TableCell className="py-4 px-4 text-sm text-center text-cyellow font-semibold tracking-wide">
                  {formatSmsCount(item?.total_sms_send)}
                </TableCell>
                <TableCell className="py-4 px-4 text-sm text-center text-cgreen1 font-semibold">
                  {formatPerSmsCharge(item?.per_sms_charge)}
                </TableCell>
                <TableCell className="py-4 px-4 text-sm text-right text-cyellow font-semibold">
                  {formatTotalCharge(item?.total_charge)}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}

export default SmsUsageHistoryTable;
